import { SsoConnection } from '@choco-admin/types';

import { useSsoPageConnectionsQuery } from '../../../generated';
import { mapToSsoConnections } from '../utils';

export interface UseSsoConnectionsResult {
  connections: SsoConnection[];
  isLoading: boolean;
  error: Error | null;
  refetch: () => void;
}

export const useSsoConnections = (): UseSsoConnectionsResult => {
  const { data, loading, error, refetch } = useSsoPageConnectionsQuery({
    fetchPolicy: 'cache-and-network',
  });

  const result = data?.ssoConnections;

  const authorizationError =
    result?.__typename === 'AuthorizationFailure'
      ? new Error(result.message ?? 'Not authorized to view SSO connections.')
      : null;

  return {
    connections:
      result?.__typename === 'SsoConnectionList'
        ? mapToSsoConnections(result.connections)
        : [],
    isLoading: loading,
    error: error ?? authorizationError,
    refetch: () => {
      refetch();
    },
  };
};
